<div [ngClass]="{ 'loader-hidden': !show }">
  <div class="loader-overlay">
    <mat-progress-spinner mode="indeterminate" *ngIf="show"></mat-progress-spinner>
  </div>
</div>
